import { atom } from 'jotai'

export type EditorStep = 'CUSTOMER_AND_LINE_ITEMS' | 'TERMS' | 'SUMMARY'
export const currentEditorStepAtom = atom<EditorStep>('CUSTOMER_AND_LINE_ITEMS')
